import { MutationResult } from "@apollo/client";
import { MutationHookOptions } from "@apollo/client/react/types/types";
import { UPDATE_MATTER_TEMPLATE } from "../../graphql/mutation";
import { useCallback } from "react";
import {
  updateMatterTemplate,
  updateMatterTemplateVariables,
} from "../../graphql/__generated_types__/updateMatterTemplate";
import { FetchResult } from "@apollo/client/link/core";
import { useMutation } from "../use-mutation";
import { MatterUpdateInput } from "../../graphql/__generated_types__/globalTypes";

export type UpdateMatterTemplateMutationResult = MutationResult<updateMatterTemplate>;
export type UpdateMatterTemplateFunction = (
  input: MatterUpdateInput,
  id: number
) => Promise<FetchResult<updateMatterTemplate>>;

export function useUpdateMatterTemplateMutation(
  options?: MutationHookOptions<updateMatterTemplate, updateMatterTemplateVariables>
): [UpdateMatterTemplateFunction, UpdateMatterTemplateMutationResult] {
  const [update, result] = useMutation<updateMatterTemplate, updateMatterTemplateVariables>(
    UPDATE_MATTER_TEMPLATE,
    options
  );
  const callback = useCallback<UpdateMatterTemplateFunction>(
    (data, id) => update({ variables: { data, id } }),
    [update]
  );
  return [callback, result];
}
